import React from 'react';
import { Box } from '@chakra-ui/react';
import { StarIcon } from '@chakra-ui/icons';

interface CustomPopularArticlesIconProps {
  color?: string;
  size?: string; // optional size (default: '24px')
}

export const CustomPopularArticlesIcon: React.FC<CustomPopularArticlesIconProps> = ({
  color = 'black',
  size = '24px',
}) => {
  return (
    <Box
      w={size}
      h={size}
      bg={color}
      borderRadius="sm"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <StarIcon color="white" boxSize={`calc(${size} * 0.75)`} />
    </Box>
  );
};
